import {Box, Checkbox, Input, Textarea} from "@chakra-ui/react"
import Select from 'react-select';
import {useState} from "react";
export const PropertyValueSelector = ({property, onValueChange}: any) => {

  const [value, setValue] = useState(null);

  const handleChange = (newValue) => {
    setValue(newValue);
    onValueChange(newValue);
  };

  switch (property.type) {
  case "checkbox":
    return (
      <Checkbox onChange={e => handleChange(e.target.checked ?? false)} defaultChecked={false}/>
    );
  case "date":
    return (
      <Input type="date" onChange={e => handleChange(e.target.value)} defaultValue={""}/>
    );
  case "email":
    return (
      <Input type="email" onChange={e => handleChange(e.target.value)} defaultValue={""}/>
    );
  case "multi_select":
    return (
      <Select
        isMulti
        isSearchable={false}
        closeMenuOnSelect={false}
        options={property.multi_select.options.map(option => ({
          label: option.name,
          value: option.name
        }))}
        onChange={(data) => handleChange(data)}
        placeholder="Select option"
      />
    );
  case "rich_text":
    return (
      <Textarea onChange={e => handleChange(e.target.value)} defaultValue={""}/>
    );
  case "select":
    return (
      <Select
        isSearchable={false}
        options={property.select.options.map(option => ({
          label: option.name,
          value: option.name
        }))}
        onChange={(data) => handleChange(data)}
        placeholder="Select option"
        isClearable
      />
    );
  case "status":
    return (
      <Select
        isSearchable={false}
        options={property.status.options.map(option => ({
          label: option.name,
          value: option.name
        }))}
        onChange={(data) => handleChange(data)}

        placeholder="Select status"
      />
    );
  case "title":
    return (
      <Input onChange={e => handleChange(e.target.value)} defaultValue={""}/>
    );
  case "url":
    return (
      <Input onChange={e => handleChange(e.target.value)} type="url" defaultValue={""}/>
    );
  case "number":
    return (
      <Input onChange={e => handleChange(e.target.value)} type="number" defaultValue={""}/>
    )
  }

  return <Box>
    Not supported
  </Box>
}